import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Axios } from "./../../config/axios.js";
import Logo from "./../../assets/logo.jpg";
import { MdLock, MdEmail } from "react-icons/md";
import { FaUser } from "react-icons/fa";
function Login() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onLogin = async () => {
    if (!name && !email && !password) {
      alert("Empty Fiels!");
    }
    setLoader(true);

    await Axios.post("/users", {
      name: name,
      email: email,
      password: password,
    })
      .then(function (response) {
        if (response.data.success === false) {
          setLoader(false);
          alert(response.data.message);
        }
        if (response.data.success === true) {
          console.log(response);
          localStorage.setItem(
            "jwt_authorization",
            JSON.stringify(response.data.user)
        );
          setLoader(false);
          if (response.data.user.role === "admin") {
            navigate("/admin/dashboard");
          } else if (response.data.user.role === "user") {
            navigate("/dashboard");
          } else {
            navigate("/");
          }
        }
      })
      .catch(function (error) {
        alert("Error occured");
        setLoader(false);
      });
  };
  return (
    <>
      <div className="container">
        <div className="form_box">
          <div className="form_box_inner">
            <img src={Logo} alt="" className="logo" />
            <br />
            <br />
            <div className="form_input_group">
              <div className="input_feild">
                <FaUser className="_icon" />
                <input
                  type="text"
                  placeholder="Username"
                  id="username"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="input_feild">
                <MdEmail className="_icon" />
                <input
                  type="email"
                  placeholder="Your Email"
                  value={email}
                  id="email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="input_feild">
                <MdLock className="_icon" />
                <input
                  type="password"
                  id="password"
                  placeholder="Your Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <p className="form_links">
                Already have an Account? <Link to="/">Login</Link>
              </p>
              <br />
              <button className="primary_btn" onClick={() => onLogin()}>
                {loader ? "loading" : "Register"}
              </button>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
